import { render, staticRenderFns } from "./PaymentMethodType.vue?vue&type=template&id=43e4a654&"
import script from "./PaymentMethodType.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports